__turbopack_context__.v({
  "heroImage": "Illustration-module-scss-module__f7a3fG__heroImage",
  "item": "Illustration-module-scss-module__f7a3fG__item",
  "list": "Illustration-module-scss-module__f7a3fG__list",
  "primary": "Illustration-module-scss-module__f7a3fG__primary",
  "root": "Illustration-module-scss-module__f7a3fG__root",
  "secondary": "Illustration-module-scss-module__f7a3fG__secondary",
});
